import { Rule, Rules } from '../types';

export const useInitialClonedRulesErrorCheck = (clonedRules: Rules = []) => {
  const hasInvalidRules = clonedRules?.some(
    (r: Rule & { containsCloningError?: boolean }) => r?.containsCloningError === true,
  );
  // logic behind this is that the ff must be enabled for it to be a cloned exit rule
  // additionally if there are any exitRules that have the field containsCloningError === true
  // it should truly be a initially loaded cloned exit rule
  return hasInvalidRules;
};
